// extracted by mini-css-extract-plugin
export default {"content_row":"ContentRow_content_row__EN3Nu","fill_remaining":"ContentRow_fill_remaining__xwbdd","inner_wrapper":"ContentRow_inner_wrapper__PjZcd"};